import { z } from "zod";

export const handleMarketingEmailUnsubscribeSchema = {
  input: z.object({ token: z.string() }),
  output: z.object({}),
};
